export const USER_LOADING = "USER_LOADING";
export const LOGIN_SUCCES = "LOGIN_SUCCES";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const CLEAN_LOGIN = "limpiar_todo_login";
